<template>
  <v-layout row wrap justify-space-around class="bg-android" justify-center>
    <v-flex class="bg-phone" xl4 lg4 md4 sm4 xs12 style="overflow: hidden;">
      <div class="phone-img">
        <v-img :src="src" position="center"></v-img>
      </div>
    </v-flex>
    <v-flex xl8 lg8 md8 sm8 xs12>
      <div class="flagpic">
        <v-img id="v-img" :src="flagsrc"></v-img>
      </div>
      <div class="text-xs-center mt-4 txt-app">اپلیکیشن اندروید سافاری را به زودی دانلود کنید!</div>
      <div class="text-xs-center large">
        <v-btn class="btn-app font-weight-bold" color="#7ece33" dark round>
          دانلود اپلیکیشن اندروید
          <v-avatar>
            <v-icon left color="white">android</v-icon>
          </v-avatar>
        </v-btn>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    data() {
        return {
            src: require('../../assets/cell-min.png'),
            flagsrc: require('../../assets/flag.png'),
        }
    }
};
</script>

<style scoped>
.bg-android {
  background: url("../../assets/d.jpg") no-repeat center;
  height: 300px;
  background-size: cover;
}
.phone-img {
  padding-top: 5px;
  width: 240px;
  height: 250px;
  text-align: center;
  margin: auto;
}
.flagpic {
  width: 210px;
  height: 106px;
  margin: auto;
  position: relative;
  top: 30px;
}
.txt-app {
  /* margin-top: 100px !important; */
  font-size: 23px;
  margin-bottom: 20px;
}
@media (max-width: 600px) {
  .bg-phone {
    display: none;
  }
}
.btn-app {
  height: 50px !important;
}
.btn-app:hover {
  color: #f0ff00 !important;
}
</style>
